import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const VatDisclaimer = styled.div`
    margin-top: ${getPurpurSpacing('150')};
    color: ${getPurpurColor('textMedium')};
`;
